import { AppRoutes } from '../routes/AppRoutes'

export function App() { return <AppRoutes /> }
